'use client'

import type { Editor } from '@tiptap/react'
import { undoRedoButtons } from './editor-toolbar.config'
import { EditorToolbarButtonGroup } from './editor-toolbar-button-group.atom'
import { EditorToolbarDivider } from './editor-toolbar-divider.atom'

export interface EditorToolbarUndoRedoProps {
  editor: Editor
  isDisabled?: boolean
}

/**
 * Undo/Redo buttons section for the editor toolbar
 */
export const EditorToolbarUndoRedo = ({
  editor,
  isDisabled = false,
}: EditorToolbarUndoRedoProps) => (
  <>
    <EditorToolbarButtonGroup
      editor={editor}
      buttonList={undoRedoButtons}
      isDisabled={isDisabled}
    />
    <EditorToolbarDivider />
  </>
)

EditorToolbarUndoRedo.displayName = 'EditorToolbarUndoRedo'
